/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { isEqual } from 'lodash';
import { type Dispatch, type SetStateAction, useState } from 'react';

export function useMemoizedState<T>( initialValue: T ): [ T, Dispatch<SetStateAction<T>> ] {
	const [ state, _setState ] = useState<T>( initialValue );

	const setState: Dispatch<SetStateAction<T>> = valueOrFunction => {
		_setState( prev => {
			const newState = valueOrFunction instanceof Function ? valueOrFunction( prev ) : valueOrFunction;

			if ( isEqual( newState, prev ) ) {
				return prev;
			}

			return newState;
		} );
	};

	return [ state, setState ];
}
